<template>
  <div>
    <SOSlotBase
      :bg-grey="true"
      :container-name="'landing-page-transaksi-dan-penghapusan'"
    >
      <template v-slot:title-bar>
        <SOTitleBar
          :page-title="'Transaksi & Penghapusan'"
          :type="'back'"
          @back="back"
        />
      </template>

      <template v-slot:content>
        <div
          v-for="(menu, key) in listMenu"
          :key="`list-menu-transaksi-penghapusan${key}`"
        >
          <div class="p-x-20">
            <label class="f-16 f-regular f-c-midgrey p-y-12 mb-0">
              {{ menu.name }}
            </label>
            <div
              v-for="(item, key) in menu.items"
              :key="`menu-item-transaksi-penghapusan${key}`"
            >
              <div class="m-x-min border-bottom">
                <SOMenuItemRegular
                  v-if="showMenu(item)"
                  :title="item.name"
                  @detail="() => linkTo(item)"
                />
              </div>
            </div>
          </div>
        </div>
      </template>
    </SOSlotBase>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOMenuItemRegular from "@/so-components/global/ui/SOMenuItemRegular";
import store from "@/store";

const moduleName = "penghapusanTransaksiGlobalModule";

export default {
  name: "TransaksiPenghapusan",
  components: {
    SOSlotBase,
    SOTitleBar,
    SOMenuItemRegular,
  },
  computed: {
    ...mapGetters(moduleName, {
      listMenu: "listMenus",
    }),
    useWhitelabel() {
      return this.$store.state.metaModule.isWhitelabel ? true : false;
    },
  },
  mounted() {
    store.commit('metaModule/setWhitelabelSetting', JSON.parse(localStorage.getItem('whitelabelSetting')))

    console.log(this.useWhitelabel)
    this.smartTrackingView("transaksi_dan_pembatalan");
  },
  methods: {
    back() {
      this.$router.push({ name: "dashboard" });
    },
    showMenu(item) {
      if (item.isWhitelabel == true) {
        return this.useWhitelabel;
      }
      return true;
    },
    linkTo(item) {
      if (item.isWebview ?? false) {
        this.flutterNavigate(item.linkTo, true)
      } else  {
        this.$router.push({ name: item.linkTo });
      }
      this.smartTrackingClick(item.name.replaceAll(" ", "_").toLowerCase());
    },
  },
};
</script>
